import { gql, type TypedDocumentNode } from "@apollo/client";

export type FinalizeAttendanceResponse = {
  finalizeAttendance: {
    success: boolean;
    message: string;
    event: {
      id: string;
      finalizedAt: string | null;
    } | null;
  };
};

export type FinalizeAttendanceVariables = {
  eventId: string;
};

export const FINALIZE_ATTENDANCE_MUTATION: TypedDocumentNode<FinalizeAttendanceResponse, FinalizeAttendanceVariables> =
  gql`
    mutation FinalizeAttendance($eventId: ID!) {
      finalizeAttendance(eventId: $eventId) {
        success
        message
        event {
          id
          finalizedAt
        }
      }
    }
  `;
